var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsSignOutNoArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5,
    height: 15,
    viewBox: "0 0 5 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1797 -35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,0H1A0,0,0,0,1,1,0V15a0,0,0,0,1,0,0H1a1,1,0,0,1-1-1V1A1,1,0,0,1,1,0Z",
    transform: "translate(1797 35)",
    fill: "#3a3630"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H3.5A.5.5,0,0,1,4,.5v0a.5.5,0,0,1-.5.5H0A0,0,0,0,1,0,1V0A0,0,0,0,1,0,0Z",
    transform: "translate(1798 49)",
    fill: "#3a3630"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H3.5A.5.5,0,0,1,4,.5v0a.5.5,0,0,1-.5.5H0A0,0,0,0,1,0,1V0A0,0,0,0,1,0,0Z",
    transform: "translate(1798 35)",
    fill: "#3a3630"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsSignOutNoArrow);
export default __webpack_public_path__ + "static/media/icons_SignOutNoArrow.d63bce3b.svg";
export { ForwardRef as ReactComponent };